module.exports = __webpack_public_path__ + "static/img/icon_tick@2x.c5278bbd.png";